module.exports = __webpack_public_path__ + "img/pdf-icon.218664a8.png";